export default __webpack_public_path__ + "static/media/avatar.00d4ecf9.png";